export class HttpError extends Error {
    status;
    constructor(status, message) {
        super(message);
        this.name = 'HttpError';
        this.status = status;
    }
}
const toSearchParams = (params) => new URLSearchParams(Object.entries(params)
    .filter((entry) => entry[1] !== null && entry[1] !== undefined)
    .flatMap(([key, value]) => Array.isArray(value)
    ? value.map(item => [key, String(item)])
    : [[key, String(value)]]));
const problemMessage = async (response) => {
    const problem = await response.json().catch(() => null);
    return problem?.title || problem?.detail || `Request failed (${response.status}).`;
};
export const getJson = (url, searchParams) => async (signal) => {
    const query = searchParams ? `?${toSearchParams(searchParams)}` : '';
    const response = await fetch(`${url}${query}`, {
        'signal': signal,
        'headers': { 'Accept': 'application/json' },
    });
    if (!response.ok) {
        throw new HttpError(response.status, await problemMessage(response));
    }
    return response.json();
};
export const withDone = (request) => request();
export const withAbort = (request) => {
    const controller = new AbortController();
    return [(signal) => request(signal || controller.signal), () => controller.abort()];
};
